import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        recaAportes: []
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Recaudo?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("reca_aportes/borrar/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarRecaAportes(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    ListarRecaAportes(page) {
        Swal.showLoading();
        let bestado = document.getElementById('bestado').value;
        let bperiodo = document.getElementById('bperiodo').value;
        let bname = document.getElementById('bnombre').value;
        if (bestado == '') {
            bestado = 0;
        }
        if (bperiodo == '') {
            bperiodo = 0;
        }
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("reca_aportes/index/" + bestado + "/" + bperiodo + "/" + bname + "?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', recaAportes: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarRecaAportes(1);
    }
    render() {
        const { load, recaAportes, pagina, ultimo, actual } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddRecaAportesMunicipales"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Recaudo</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Recaudos Aportes Municipales</h4>
                            <hr />
                            <div className="row">
                                <div className='col-md-12'>
                                    <div className="accordion" id="accordionExample">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header" id="headingOne">
                                                <button style={{ fontSize: 14 }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    <b>FILTROS</b>
                                                </button>
                                            </h2>
                                            <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne">
                                                <div className="accordion-body">
                                                    <div className='row'>
                                                        <div className="col-xl-2">
                                                            <label htmlFor="bestado">Estado Factura</label>
                                                            <select name="bestado" id="bestado"
                                                                className={"form-select form-select-sm"}
                                                                onChange={this.cambioValor}>
                                                                    <option value="">-</option>
                                                                    <option value="1">ENTREGADO</option>
                                                                    <option value="2">PENDIENTE DE ENVÍO</option>
                                                                    <option value="3">RECLAMADA</option>
                                                                    <option value="4">PAGADA</option>
                                                                    <option value="5">PAGO PARCIAL</option>
                                                                    <option value="6">PAGO POR ACUERDO</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-xl-2">
                                                            <label htmlFor="bperiodo">Periodo</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="number" id="bperiodo" name="bperiodo" placeholder="PERIODO" min="0" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="bnombre">Municipio</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="MUNICIPIO" className="form-control form-control-sm" />
                                                        </div>
                                                        <div style={{ marginTop: 32 }} className="col-xl-1">
                                                            <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarRecaAportes(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className='col-xl-12'>
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">ESTADO</th>
                                                <th className="align-middle">DEPARTAMENTO</th>
                                                <th className="align-middle">MUNICIPIO</th>
                                                <th className="align-middle">CUENTA COBRO</th>
                                                <th className="align-middle">VALOR FACTURA</th>
                                                <th className="align-middle">PERIODO</th>
                                                <th className="align-middle">OPCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                recaAportes.map((itemRecaAportes) => (
                                                    <tr key={itemRecaAportes.ID_RECAUDO}>
                                                        {
                                                            (() => {
                                                                switch (itemRecaAportes.ESTADO_RECAUDO) {
                                                                    case 1:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">E</span></td>)
                                                                    case 2:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#ADAEAF' }} className="badge">PE</span></td>)
                                                                    case 3:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#4D7B52' }} className="badge">R</span></td>)
                                                                    case 4:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">P</span></td>)
                                                                    case 5:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#66C77E' }} className="badge">PP</span></td>)
                                                                    case 6:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-warning">PA</span></td>)

                                                                }
                                                            })()
                                                        }
                                                        <td>{itemRecaAportes.DEPARTAMENTO}</td>
                                                        <td>{itemRecaAportes.MUNICIPIO}</td>
                                                        <td>{itemRecaAportes.CONSECUTIVO_FACT}</td>
                                                        <td><b>$ </b>{currencyFormat(itemRecaAportes.VALOR_RECAUDO)}</td>
                                                        <td>{itemRecaAportes.PERIODO_FACTURA}</td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpRecaAportesMunicipales/" + itemRecaAportes.ID_RECAUDO}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.borrarRegistros(itemRecaAportes.ID_RECAUDO)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">E</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>ENTREGADO</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">P</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>PAGADA</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-warning">PA</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>PAGADO POR ACUERDO</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#66C77E' }} className="badge">PP</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>PAGO PARCIAL</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#ADAEAF' }} className="badge">PE</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>PENDIENTE ENVÍO</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#4D7B52' }} className="badge">R</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>RECLAMADA</b></span>&nbsp;
                            <nav style={{ marginTop: 15 }} aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRecaAportes(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRecaAportes(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarMunicipio(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRecaAportes(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRecaAportes(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;